import "../../index.css"

const Card = ({ title, subtitle, content }) => {
    return (
            <div className="w-64 lg:w-80 lg:h-56 bg-light-pink p-6 rounded-3xl">
                <h4 className="text-black font-bold text-sm ">{title}</h4>
                {subtitle && <p className="text-black text-xs mb-4">{subtitle}</p>}
                <p className={`text-black text-xs ${!subtitle && "mt-4"}`}>{content}</p>
            </div>
    )
}

export default Card;